<p-panel>
    <app-reactive-form-builder
        (goBack)="goBack()"
        [form]="form.formFields"
        [id]="reactiveFormRecordId"
        [request]="request"
        [getRequest]="productosApi.productos.GET">
    </app-reactive-form-builder>
</p-panel>
<br>
